import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions } from "@mui/material";

interface Props {
  open: boolean;
  onClose: () => void;
  uploadFiles: {
    idProofFront: File | null;
    idProofBack: File | null;
    paymentReceipt: File | null;
  };
  setUploadFiles: React.Dispatch<React.SetStateAction<any>>;
  onUpload: () => void;
  uploading: boolean;
}

const VerificationUploadDialog = ({ open, onClose, uploadFiles, setUploadFiles, uploading, onUpload }: Props) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle>
        <h3>Upload Verification Documents</h3>
      </DialogTitle>

      <DialogContent>
        <div className='form-group'>
          <label>ID Proof Front</label>

          <input
            type='file'
            accept='image/jpeg,image/png,image/webp,image/heic,image/heif'
            onChange={(e) =>
              setUploadFiles((prev: any) => ({
                ...prev,
                idProofFront: e.target.files?.[0] || null,
              }))
            }
          />
        </div>

        <div className='form-group'>
          <label>ID Proof Back</label>

          <input
            type='file'
            accept='image/jpeg,image/png,image/webp,image/heic,image/heif'
            onChange={(e) =>
              setUploadFiles((prev: any) => ({
                ...prev,
                idProofBack: e.target.files?.[0] || null,
              }))
            }
          />
        </div>

        <div className='form-group'>
          <label>Payment Receipt</label>

          <input
            type='file'
            accept='image/jpeg,image/png,image/webp,image/heic,image/heif'
            onChange={(e) =>
              setUploadFiles((prev: any) => ({
                ...prev,
                paymentReceipt: e.target.files?.[0] || null,
              }))
            }
          />
        </div>
      </DialogContent>

      <DialogActions>
        <button className='btn-outline' onClick={onClose}>
          Cancel
        </button>

        <button className='btn-primary' onClick={onUpload} disabled={uploading}>
          {uploading ? "Uploading..." : "Upload Documents"}
        </button>
      </DialogActions>
    </Dialog>
  );
};

export default VerificationUploadDialog;
